/**
 * Cabins toggle functionality
 * Toggles the details section of each cabin when clicking the "Read More" button
 */

document.addEventListener("DOMContentLoaded", function () {
	// Select all cabin items
	const cabinItems = document.querySelectorAll(".cabin-item");

	cabinItems.forEach(function (cabin) {
		// Find the button and details section within each cabin
		const toggleButton = cabin.querySelector(".toggle-active");
		const detailsSection = cabin.querySelector(".details");

		if (toggleButton && detailsSection) {
			toggleButton.addEventListener("click", function (e) {
				e.preventDefault();

				const isCurrentlyActive =
					detailsSection.classList.contains("active");

				// Toggle the active class on the details section
				detailsSection.classList.toggle("active");
				cabin.classList.toggle("expanded");

				// Change button text based on state
				if (!isCurrentlyActive) {
					toggleButton.textContent = "See Less";
				} else {
					toggleButton.textContent = "See More";
				}
			});
		}
	});
});
